import axios from 'axios'

interface CommonHttpResponseBody {
  status: boolean
  errorCode?: string
  errorMessage?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
}

const axiosInstance = axios.create({
  baseURL: '/',
})

axiosInstance.interceptors.response.use(
  (response) => {
    const responseBody = response.data as CommonHttpResponseBody

    if (!responseBody.status) {
      return Promise.reject(responseBody)
    }

    // 正确响应直接返回 data 属性
    return responseBody.data
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default axiosInstance
